// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-table-thead > tr > th {
  border-right: none !important;
  padding: 8px !important;
}

.password-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
}
.password-cell > div {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.password-cell .password-edit-button {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  color: var(--color-text-subtle);
  font-size: 20px;
  margin-left: 4px;
}

.company-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
}
.company-cell > div {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.company-cell .company-edit-button {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  color: var(--color-text-subtle);
  font-size: 20px;
  margin-left: 4px;
}

.password-edit-button:hover,
.company-edit-button:hover {
  color: var(--color-primary-hover) !important;
}

.group-dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
  width: 100%;
}
.group-dropdown-trigger:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.group-dropdown-trigger .dropdown-icon {
  margin-left: auto;
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.2s;
}
.group-dropdown-trigger:hover .dropdown-icon {
  opacity: 1;
}

.group-dropdown-menu {
  padding: 8px 0;
}
.group-dropdown-menu .group-radio-list {
  padding: 4px 8px;
  max-height: 200px;
  overflow-y: auto;
}
.group-dropdown-menu .group-radio-list .group-radio-item {
  display: block;
  margin: 8px 0;
  white-space: nowrap;
}

.group-radio-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.group-radio-item:hover {
  background-color: #f5f5f5;
}
.group-radio-item .ant-radio-wrapper {
  width: 100%;
}

.dropdown-container {
  position: relative;
  width: 100%;
  max-width: 150px;
  margin: 0 auto;
}
.dropdown-container .group-dropdown-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
.dropdown-container .group-dropdown-trigger:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.ant-table-tbody > tr > td {
  padding: 10px !important;
  border-bottom-color: var(--color-border) !important;
}

.ant-table-thead > tr > th {
  border-bottom-color: var(--color-border) !important;
}

.ant-table-tbody > tr {
  height: auto !important;
}

.group-radio-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.group-radio-item .ant-radio-wrapper {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wrapper-table .group-dropdown-overlay .ant-dropdown-menu {
  min-width: 180px !important;
  max-width: 180px !important;
  overflow: visible !important;
}
.wrapper-table .group-dropdown-overlay .ant-dropdown-menu .ant-dropdown-menu-item {
  padding: 5px 12px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wrapper-table .ant-table-tbody > tr {
  transition: background-color 0s !important;
  background-color: transparent !important;
}
.wrapper-table .ant-table-tbody > tr > td {
  transition: background-color 0s !important;
  background-color: transparent !important;
}
.wrapper-table .ant-table-tbody > tr:hover {
  background-color: #fafafa !important;
  transition: background-color 0s !important;
}
.wrapper-table .ant-table-tbody > tr:hover > td {
  background-color: #fafafa !important;
  transition: background-color 0s !important;
}
.wrapper-table .ant-table-tbody > tr:not(:hover) {
  background-color: transparent !important;
  transition: background-color 0s !important;
}
.wrapper-table .ant-table-tbody > tr:not(:hover) > td {
  background-color: transparent !important;
  transition: background-color 0s !important;
}
.wrapper-table .ant-table-tbody > tr td .password-edit-button,
.wrapper-table .ant-table-tbody > tr td .company-edit-button,
.wrapper-table .ant-table-tbody > tr td .group-dropdown-trigger .dropdown-icon {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease-in-out;
}
.wrapper-table .ant-table-tbody > tr:hover td .password-edit-button,
.wrapper-table .ant-table-tbody > tr:hover td .company-edit-button,
.wrapper-table .ant-table-tbody > tr:hover td .group-dropdown-trigger .dropdown-icon {
  opacity: 1;
  pointer-events: auto;
}
.wrapper-table .ant-table-tbody > tr:hover .group-dropdown-trigger {
  background-color: rgba(255, 255, 255, 0.2);
}

.user-tooltip .ant-tooltip-inner {
  background-color: #2DACEC !important;
  color: #ffffff !important;
  font-size: 12px !important;
  padding: 4px 12px !important;
  border-radius: 4px !important;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16) !important;
  max-width: 250px !important;
  min-height: 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
}
.user-tooltip .ant-tooltip-arrow {
  width: 16px !important;
  height: 16px !important;
}
.user-tooltip .ant-tooltip-arrow::before,
.user-tooltip .ant-tooltip-arrow::after,
.user-tooltip .ant-tooltip-arrow-content,
.user-tooltip .ant-tooltip-arrow-inner {
  background-color: #2DACEC !important;
}

.cursor-pointer-column {
  cursor: pointer;
}

.no-cursor-column .ant-table-cell {
  cursor: default;
}

.password-cell, .company-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.password-cell .password-edit-button, .password-cell .company-edit-button, .company-cell .password-edit-button, .company-cell .company-edit-button {
  padding: 0;
  margin-left: 8px;
}

.group-dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.group-dropdown-trigger .dropdown-icon {
  margin-left: 8px;
}

.delete-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.delete-button-container .delete-button {
  font-size: 17px;
  cursor: pointer;
  color: var(--color-text-subtle);
  transition: color 0.15s ease-in-out;
}
.delete-button-container .delete-button:hover {
  color: var(--color-danger);
}

.ant-table-tbody > tr:hover .delete-button-container .delete-button:not(:hover) {
  color: var(--color-text);
}`, "",{"version":3,"sources":["webpack://./src/pages/User/component/TableUser.scss"],"names":[],"mappings":"AACA;EACE,6BAAA;EACA,uBAAA;AAAF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AADF;AAGE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAIE;EAEE,UAAA;EACA,oCAAA;EAGA,+BAAA;EACA,eAAA;EACA,gBAAA;AALJ;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAPF;AASE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAPJ;AAUE;EAEE,UAAA;EACA,oCAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AATJ;;AAkCA;;EAEE,4CAAA;AA/BF;;AAgEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,WAAA;AA7DF;AA+DE;EACE,0CAAA;AA7DJ;AAgEE;EACE,iBAAA;EACA,eAAA;EACA,UAAA;EACA,wBAAA;AA9DJ;AAiEE;EACE,UAAA;AA/DJ;;AAmEA;EACE,cAAA;AAhEF;AAkEE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAhEJ;AAkEI;EACE,cAAA;EACA,aAAA;EACA,mBAAA;AAhEN;;AAiFA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iCAAA;AA9EF;AAgFE;EACE,yBAAA;AA9EJ;AAiFE;EACE,WAAA;AA/EJ;;AAoFA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAjFF;AAmFE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;AAjFJ;AAmFI;EACE,0CAAA;AAjFN;;AAuFA;EACE,wBAAA;EAGA,mDAAA;AAtFF;;AA0FA;EACE,mDAAA;AAvFF;;AA2FA;EACE,uBAAA;AAxFF;;AA4FA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzFF;AA2FE;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;AAzFJ;;AAgGI;EACE,2BAAA;EACA,2BAAA;EACA,4BAAA;AA7FN;AA+FM;EACE,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA7FR;AAmGE;EAEE,0CAAA;EACA,wCAAA;AAlGJ;AAoGI;EACE,0CAAA;EACA,wCAAA;AAlGN;AAqGI;EACE,oCAAA;EACA,0CAAA;AAnGN;AAqGM;EACE,oCAAA;EACA,0CAAA;AAnGR;AAuGI;EACE,wCAAA;EACA,0CAAA;AArGN;AAuGM;EACE,wCAAA;EACA,0CAAA;AArGR;AA6GM;;;EAGE,UAAA;EACA,oBAAA;EACA,qCAAA;AA3GR;AAiHQ;;;EAGE,UAAA;EACA,oBAAA;AA/GV;AAmHM;EACE,0CAAA;AAjHR;;AAyHE;EACE,oCAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;EACA,oDAAA;EACA,2BAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,yBAAA;AAtHJ;AAyHE;EACE,sBAAA;EACA,uBAAA;AAvHJ;AA0HE;;;;EAIE,oCAAA;AAxHJ;;AAmIA;EACE,eAAA;AAhIF;;AAqIE;EACE,eAAA;AAlIJ;;AAuIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AApIF;AAsIE;EAEE,UAAA;EACA,gBAAA;AArIJ;;AAiJA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA9IF;AAgJE;EACE,gBAAA;AA9IJ;;AAuJA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AApJF;AAsJE;EACE,eAAA;EACA,eAAA;EACA,+BAAA;EACA,mCAAA;AApJJ;AAsJI;EACE,0BAAA;AApJN;;AA0JA;EACE,wBAAA;AAvJF","sourcesContent":["// 테이블 헤더 스타일\n.ant-table-thead > tr > th {\n  border-right: none !important;\n  padding: 8px !important;\n}\n\n// Password 컬럼 스타일\n.password-cell {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  \n  > div {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n  }\n\n  .password-edit-button {\n    // visibility: hidden;  // 251204 : delete\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n    // 색은 테마 토큰을 씁니다. 예전에는 #e5e5e5 고정이라 다크에서만 보이고\n    // 라이트에서는 흰 배경에 묻혀 연필이 사라졌습니다.\n    color: var(--color-text-subtle);\n    font-size: 20px;\n    margin-left: 4px;\n  }\n}\n\n// Company 컬럼 스타일\n.company-cell {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  \n  > div {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n  }\n\n  .company-edit-button {\n    // visibility: hidden;  // 251204 : delete\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n    color: var(--color-text-subtle);\n    font-size: 20px;\n    margin-left: 4px;\n  }\n}\n\n// 251204 : delete - start\n// // 행에 마우스 호버 시 연필 버튼 표시\n// .ant-table-tbody > tr:hover {\n//   .password-cell .password-edit-button,\n//   .company-cell .company-edit-button {\n//     visibility: visible;\n//     opacity: 1;\n//   }\n// }\n// 251204 : delete - end\n\n// 연필에 직접 올렸을 때. 삭제 아이콘이 danger 로 짙어지는 것과 같은 방식으로\n// 짙어집니다. white 고정이던 시절에는 라이트에서 오히려 사라졌습니다.\n//\n// primary 가 아니라 primary-hover 를 씁니다. 라이트의 primary(sky-500)는 행 호버\n// 배경(slate-200) 위에서 대비가 2.25:1 로 오히려 기본 상태보다 흐려집니다.\n// History 테이블의 같은 성격 아이콘들도 primary-hover 를 씁니다.\n//\n// !important 는 필요해서 붙어 있습니다. antd 의 hover 규칙이 :not() 두 개를\n// 겹쳐 (0,4,0) 이라 이 선택자(0,2,0)로는 이기지 못합니다. 기본 상태 쪽은\n// (0,1,0) 이라 !important 없이 이깁니다.\n.password-edit-button:hover,\n.company-edit-button:hover {\n  color: var(--color-primary-hover) !important;\n}\n\n// 251204 : delete - start\n// .delete-button {\n//   // width: 24px; // 버튼의 너비 조정\n//   // height: 24px; // 버튼의 높이 조정\n//   cursor: pointer;\n//   visibility: hidden;\n//   // opacity: 0.5; // 기본 불투명도\n//   // transition: opacity 0.3s; // 부드러운 전환 효과\n// }\n\n// .delete-button-container img {\n//   visibility: hidden;\n//   // transition: filter 0.3s; /* 부드러운 전환 효과 추가 */\n// }\n\n// .delete-button-container:hover img {\n//   visibility: visible; /* 호버 시 보이도록 설정 */\n//   filter: brightness(0) saturate(100%) invert(100%); /* 호버 시 흰색으로 변경 */\n// }\n\n// .delete-row {\n//   &:hover {\n//     .delete-button {\n//       visibility: visible !important;\n//     }\n//   }\n// }\n// 251204 : delete - end\n\n// 그룹 드롭다운 스타일\n.group-dropdown-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n  width: 100%;\n  \n  &:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n  \n  .dropdown-icon {\n    margin-left: auto;\n    font-size: 12px;\n    opacity: 0;\n    transition: opacity 0.2s;\n  }\n  \n  &:hover .dropdown-icon {\n    opacity: 1;\n  }\n}\n\n.group-dropdown-menu {\n  padding: 8px 0;\n  \n  .group-radio-list {\n    padding: 4px 8px;\n    max-height: 200px;\n    overflow-y: auto;\n    \n    .group-radio-item {\n      display: block;\n      margin: 8px 0;\n      white-space: nowrap;\n    }\n  }\n}\n\n// 251204 : delete - start\n// // 행에 마우스 호버 시 드롭다운 아이콘 표시\n// .ant-table-tbody > tr:hover {\n//   .group-dropdown-trigger {\n//     .dropdown-icon {\n//       opacity: 1;\n//     }\n//   }\n// }\n// 251204 : delete - end\n\n// 그룹 드롭다운 스타일 수정\n.group-radio-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  \n  &:hover {\n    background-color: #f5f5f5;\n  }\n  \n  .ant-radio-wrapper {\n    width: 100%;\n  }\n}\n\n// 드롭다운 컨테이너 스타일 수정\n.dropdown-container {\n  position: relative;\n  width: 100%;\n  max-width: 150px;\n  margin: 0 auto;\n  \n  .group-dropdown-trigger {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    padding: 6px 10px;\n    border-radius: 4px;\n    transition: background-color 0.2s ease;\n    \n    &:hover {\n      background-color: rgba(255, 255, 255, 0.2);\n    }\n  }\n}\n\n// 테이블 셀 패딩 조절\n.ant-table-tbody > tr > td {\n  padding: 10px !important;\n  // 행 구분선 — antd 기본 split이 다크에서 흰색이라 흰 글자와 충돌.\n  // 토큰화로 라이트=slate-200, 다크=slate-700 옅은 구분선으로 톤 다운.\n  border-bottom-color: var(--color-border) !important;\n}\n\n// 헤더 하단 라인도 동일 토큰으로 통일.\n.ant-table-thead > tr > th {\n  border-bottom-color: var(--color-border) !important;\n}\n\n// 테이블 행 높이 조절 (선택 사항)\n.ant-table-tbody > tr {\n  height: auto !important;\n}\n\n// 그룹 라디오 아이템 텍스트 처리\n.group-radio-item {\n  white-space: nowrap;       // 텍스트 줄바꿈 방지\n  overflow: hidden;          // 넘치는 텍스트 숨김\n  text-overflow: ellipsis;   // 넘치는 텍스트에 ... 표시\n  \n  .ant-radio-wrapper {\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n// 테이블 내부 그룹 드롭다운 오버레이 스타일\n.wrapper-table {\n  .group-dropdown-overlay {\n    .ant-dropdown-menu {\n      min-width: 180px !important;\n      max-width: 180px !important;\n      overflow: visible !important; // 스크롤 제거\n      \n      .ant-dropdown-menu-item {\n        padding: 5px 12px !important;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n  \n  // 251204 : fix - wrapper-table 내부 테이블 행 hover 잔상 방지 (통합)\n  .ant-table-tbody > tr {\n    // 배경색 transition 완전 제거로 빠른 마우스 이동 시 잔상 방지\n    transition: background-color 0s !important;\n    background-color: transparent !important;\n    \n    > td {\n      transition: background-color 0s !important;\n      background-color: transparent !important;\n    }\n    \n    &:hover {\n      background-color: #fafafa !important;\n      transition: background-color 0s !important;\n      \n      > td {\n        background-color: #fafafa !important;\n        transition: background-color 0s !important;\n      }\n    }\n    \n    &:not(:hover) {\n      background-color: transparent !important;\n      transition: background-color 0s !important;\n      \n      > td {\n        background-color: transparent !important;\n        transition: background-color 0s !important;\n      }\n    }\n    \n    // 아이콘/버튼 opacity 제어 (통합)\n    // 삭제 아이콘은 여기서 제외합니다. 행에 올려야만 나타나면 삭제 가능한 행인지\n    // 미리 알 수 없어, 상시 노출하고 색으로만 강약을 줍니다.\n    td {\n      .password-edit-button,\n      .company-edit-button,\n      .group-dropdown-trigger .dropdown-icon {\n        opacity: 0;\n        pointer-events: none;\n        transition: opacity 0.15s ease-in-out;\n      }\n    }\n\n    &:hover {\n      td {\n        .password-edit-button,\n        .company-edit-button,\n        .group-dropdown-trigger .dropdown-icon {\n          opacity: 1;\n          pointer-events: auto;\n        }\n      }\n\n      .group-dropdown-trigger {\n        background-color: rgba(255, 255, 255, 0.2);\n      }\n    }\n  }\n}\n\n// 툴팁 스타일 추가\n.user-tooltip {\n  .ant-tooltip-inner {\n    background-color: #2DACEC !important;\n    color: #ffffff !important;\n    font-size: 12px !important;\n    padding: 4px 12px !important;\n    border-radius: 4px !important;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16) !important;\n    max-width: 250px !important;\n    min-height: 24px !important;        // 최소 높이 설정\n    display: flex !important;           // Flexbox 사용\n    align-items: center !important;     // 수직 중앙 정렬\n    justify-content: center !important; // 수평 중앙 정렬\n    line-height: 1 !important;        // 줄 간격 조정\n  }\n\n  .ant-tooltip-arrow {\n    width: 16px !important;\n    height: 16px !important;\n  }\n\n  .ant-tooltip-arrow::before,\n  .ant-tooltip-arrow::after,\n  .ant-tooltip-arrow-content,\n  .ant-tooltip-arrow-inner {\n    background-color: #2DACEC !important;\n  }\n}\n\n// 251204 : modify - start\n// 커서 스타일 관련 클래스\n// .cursor-pointer-column {\n//   .ant-table-cell {\n//     cursor: pointer;\n//   }\n// }\n.cursor-pointer-column {\n  cursor: pointer;\n}\n// 251204 : modify - end\n\n.no-cursor-column {\n  .ant-table-cell {\n    cursor: default;\n  }\n}\n\n// 기존 스타일은 그대로 유지\n.password-cell, .company-cell {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  \n  .password-edit-button, .company-edit-button {\n    // visibility: hidden;  // 251204 : delete\n    padding: 0;\n    margin-left: 8px;\n  }\n  \n  // 251204 : delete - start\n  // &:hover {\n  //   .password-edit-button, .company-edit-button {\n  //     visibility: visible;\n  //   }\n  // }\n  // 251204 : delete - end\n}\n\n.group-dropdown-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  \n  .dropdown-icon {\n    margin-left: 8px;\n  }\n}\n\n// 삭제 아이콘. 이 규칙이 유일한 정의입니다 — 예전에는 같은 선택자가 파일 안에\n// 두 번 나와 폭이 서로 달랐습니다.\n//\n// 행 호버에만 의존해 나타나던 고정 색 PNG 를 아이콘 폰트로 바꾸고 상시 노출로\n// 돌렸습니다. 색은 테마 토큰을 쓰므로 라이트/다크 양쪽에서 배경과 분리됩니다.\n.delete-button-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .delete-button {\n    font-size: 17px;\n    cursor: pointer;\n    color: var(--color-text-subtle);\n    transition: color 0.15s ease-in-out;\n\n    &:hover {\n      color: var(--color-danger);\n    }\n  }\n}\n\n// 행에 올리면 삭제 대상이 어느 행인지 분명해지도록 한 단계 진하게 만듭니다.\n.ant-table-tbody > tr:hover .delete-button-container .delete-button:not(:hover) {\n  color: var(--color-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
